import React, { useEffect } from "react";



import t from "../images/food.jpg";
import t2 from "../images/meal.jpg";
import Scrolltop from "../components/Scrolltop";
import "./aboutus.css";
import { Footer } from "../components/footer";
import Section6 from "./Section6";
import { Upperbox } from "../components/Upperbox";
import Nav from "../components/Nav";
import { Link } from "react-router-dom";
const Aboutus = () => {

 

  const sections = [
    {
      title: "Dive into India's Rich Culinary Heritage – Now Just a Click Away!",
      content: `
        Welcome to Sri Krishnaa Authentic Indian Cuisine, where the rich and vibrant flavours of India meet convenience and quality. 
        Located in the lively city of Liverpool, UK, we take pride in offering you an effortless way to enjoy traditional Indian dishes 
        through our online ordering, takeaway, and catering services. From soul-soothing curries to sizzling tandoori delights, 
        every dish is crafted with premium ingredients and a blend of authentic spices to deliver the true taste of India straight to your doorstep.
      `,
      image: t,
    },
    {
      title: "What Makes Us Stand Out",
      content: `
        • Handcrafted Indian curries, seasoned with authentic, aromatic spices<br />
        • Succulent tandoori dishes cooked in a traditional clay oven<br />
        • A wide variety of vegetarian and vegan-friendly options<br />
        • Freshly prepared naan and a selection of traditional Indian breads<br />
        • Fragrant biryanis and delightful rice dishes<br />
        • A range of indulgent Indian desserts to complete your meal<br /><br />
        Whether you're dining at home with our delivery and takeaway services or celebrating with our catering options, 
        Sri Krishnaa ensures every bite is a journey into India's rich culinary heritage.
      `,
      image: t2,
    },
    {
      title: "Our Promise – Quality, Authenticity, and Tradition",
      content: `
        At Sri Krishnaa Authentic Indian Cuisine, we believe every meal has the power to bring people together. 
        Our chefs are dedicated to using only the finest ingredients, ensuring that every dish reflects India's timeless culinary traditions. 
        From the first bite to the last, we aim to provide a dining experience that is both memorable and true to its roots.
      `,
    },
    {
      title: "Order, Savour, and Celebrate with Us Today!",
      content: `
        Craving the irresistible taste of authentic Indian cuisine? Order online, visit us for a takeaway, 
        or let us cater your next event. Join us at Sri Krishnaa to discover the magic of Indian food made with love and tradition!
      `,
    },
  ];

  return (
    <div className="page-backgroundd">
      <Upperbox />
      <Nav />

      {/* Section 1 */}
      <div className="aboutus-container" >
        <div className="aboutus-content">
          <div className="aboutus-image">
            <img src={sections[0].image} alt="About Us" className="img-aboutus" />
          </div>
          <div className="aboutus-text" data-aos="fade-down">
            <h1 className="ab-u"  >{sections[0].title}</h1>
            <p>{sections[0].content}</p>
          </div>
        </div>
      </div>

      {/* Section 2 */}
      <div className="aboutus-containere" >
        <div className="aboutus-content">
          <div className="aboutus-textt" data-aos="fade-down">
            <h1 className="ab-uo">{sections[2].title}</h1>
            <p>{sections[2].content}</p>
          </div>
        </div>
      </div>

      {/* Section 4 (Middle Section) */}
      <div>
        <Section6 />
      </div>

      {/* Section 3 */}
      <div className="aboutus-container" >
        <div className="aboutus-content">
          <div className="aboutus-text" data-aos="fade-down">
            <h1 className="ab-u">{sections[3].title}</h1>
            <p>{sections[3].content}</p>
            <div className="button-group">
  <Link to="/Contactusform">
    <button className="cta-button">Order Now</button>
  </Link>
  <Link to="/Contactusform">
    <button className="cta-button">Takeaway</button>
  </Link>
  <Link to="/Contactusform">
    <button className="cta-button">Book Catering</button>
  </Link>
</div>
          </div>
        </div>
      </div>

      {/* Section 4 */}
      <div className="aboutus-containere" >
  <div className="aboutus-content">
    <div className="aboutus-textt" data-aos="fade-down">
      <h1 className="ab-uo">{sections[1].title}</h1>
      {sections[1].content.split('<br />').map((paragraph, index) => (
        <p key={index} dangerouslySetInnerHTML={{ __html: paragraph.trim() }} />
      ))}
    </div>
    <div className="aboutus-image">
      <img src={sections[1].image} alt="What Makes Us Unique" className="img-aboutus" />
    </div>
  </div>
</div>


      <Scrolltop />
      <Footer />
    </div>
  );
};

export default Aboutus;
